/**
 * @fileoverview ログインコールバック処理API
 *
 * このファイルでは、外部認証サービスからのコールバック時に
 * バックエンドAPIと連携して認証プロセスを完了する機能を提供します。
 */

/**
 * ログインコールバック処理を実行する
 *
 * 外部認証サービス（OAuth、OIDCなど）からのリダイレクト後に、
 * 認証情報をバックエンドAPIに送信して検証し、認証プロセスを完了します。
 * 成功時にはユーザーセッションが確立され、必要なトークンが保存されます。
 *
 * @param {string} code - 認証サービスから提供された認証コード
 * @param {string} [state] - 認証リクエスト時に送信された状態パラメータ
 * @returns {Promise<void>} 認証プロセスの完了を示すPromise
 * @throws {Error} 認証失敗やAPI通信エラーが発生した場合
 */
import { fetchWithLog } from "./_fetchWithLog";

export const loginCallback = async (state: string, code: string) => {
  const bffOrigin = import.meta.env.VITE_BFF_ORIGIN;
  const loginCallbackUrl = `${bffOrigin}/v1/login/callback`;

  const queries = new URLSearchParams();
  queries.append("state", state);
  queries.append("code", code);

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: queries,
    cache: "no-cache",
    credentials: "include",
  } satisfies RequestInit;

  const req = new Request(loginCallbackUrl, options);

  const res = await fetchWithLog(req);

  if (!res.ok) {
    console.error("Failed to request login callback.");
    throw new Error("Failed to request login callback.");
  }
};
